import Topbar from "./Topbar"
import useDocumentBranding from "../../hooks/useDocumentBranding";

/**
 * Omhulsel voor de pagina's zonder login (vragenlijst, evenement, intakeformulier).
 *
 * Tot 2026-09-18 kromp dit blok naar `calc(100% - 350px)` zodra Decca's zijbalk
 * open stond. Die zijbalk werd hier echter nooit gerenderd, dus het enige
 * zichtbare gevolg was een gat van 350px. De AI-vraagfunctie op de vragenlijst
 * is weg; de breedte is daarmee onvoorwaardelijk.
 */
const LayoutOpen = ({children}) => {
    useDocumentBranding();
  return (
   <div className="main">
           <div id='page-container'>
               <Topbar />
               {children}
           </div>
       </div>
  )
}

export default LayoutOpen
